export default __webpack_public_path__ + "static/media/AMAZON1.5cfbebf1.png";